import { useContext } from "react"

import { SpeedingsStateContext, SpeedingsDispatchContext } from "./SpeedingsContext.context"

export const useSpeedingsStateContext = () => {
    const context = useContext(SpeedingsStateContext)
    if (context === undefined) {
        throw new Error("useSpeedingsContextStateContext must be used within an SpeedingsStateContext")
    }
    return context
}

export const useSpeedingsDispatchContext = () => {
    const context = useContext(SpeedingsDispatchContext)
    if (context === undefined) {
        throw new Error("useSpeedingsDispatchContext must be used within an SpeedingsDispatchContext")
    }
    return context
}

export const useSpeedingsContext = () => {
    return [useSpeedingsStateContext(), useSpeedingsDispatchContext()]
}